import { Dispatch, SetStateAction, useEffect } from 'react'

import { useGetAllCountriesQuery } from '~/redux/apis/countries-api'
import getCountryNamesFromCountryData from '~/countries/utils/countries.utils'

import CountriesDropdownOptions from './CountriesDropdownOptions'

export default function SelectOptionCountries({
  userCountry,
  setHasCountriesLoaded,
}: {
  userCountry?: string
  setHasCountriesLoaded?: Dispatch<SetStateAction<boolean>>
}): React.ReactElement {
  const { data: countriesData } = useGetAllCountriesQuery()
  const countries: string[] = getCountryNamesFromCountryData(countriesData)

  useEffect(() => {
    if (setHasCountriesLoaded && countries?.length > 0) {
      setHasCountriesLoaded(true)
    }
  }, [countries, setHasCountriesLoaded])

  return <CountriesDropdownOptions chosenCountry={userCountry} countries={countries} />
}
